import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { validateCustomerForm } from "../../utils/validators";
import { scrollToTop } from "../../utils/functions";
import ConfirmBox from "../common/ConfirmBox";
import CustomerForm from "../customer/Form";
import ButtonNext from "../ButtonNext";

const Step3 = ({
  customerData,
  additionalDrivers,
  setAdditionalDrivers,
  showDriverForm,
  setShowDriverForm,
  onComplete
}) => {
  const { t } = useTranslation();

  const [maxAdditionalDrivers, setMaxAdditionalDrivers] = useState(0);
  const [invalidFields, setInvalidFields] = useState({});
  const [driverData, setDriverData] = useState({});
  const [editIndex, setEditIndex] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [isButtonNextDisabled, setIsButtonNextDisabled] = useState(true);

  const handleAddDriver = () => {
    setDriverData({ type: "driver", isDriver: true });
    setShowDriverForm(true);
  };

  const handleEditDriver = (index) => {
    setEditIndex(index);
    setDriverData(additionalDrivers[index]);
    setShowDriverForm(true);
  };

  const handleDeleteDriver = (index) => {
    setDeleteIndex(index);
  };

  const handleConfirmDelete = () => {
    setAdditionalDrivers((prevDrivers) => prevDrivers.filter((_, i) => i !== deleteIndex));
    setDeleteIndex(null);
  };

  const handleSaveDriver = (e) => {
    e.preventDefault();
    scrollToTop();

    const { isValid, invalidFields } = validateCustomerForm(t, driverData);
    if (!isValid) {
      setInvalidFields(invalidFields);
      return;
    }

    if (editIndex !== null) {
      setAdditionalDrivers((prevDrivers) => prevDrivers.map((driver, index) => index === editIndex ? driverData : driver));
      setEditIndex(null);
    } else {
      setAdditionalDrivers((prevDrivers) => [...prevDrivers, driverData]);
    }
    setShowDriverForm(false);
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    onComplete();
  };

  useEffect(() => {
    setMaxAdditionalDrivers(customerData.isDriver ? 2 : 3);
  }, [customerData.isDriver]);

  useEffect(() => {
    setIsButtonNextDisabled(!showDriverForm ? !customerData.isDriver && additionalDrivers.length === 0 : false);
  }, [customerData.isDriver, additionalDrivers, showDriverForm]);

  useEffect(() => {
    scrollToTop();
    if (!showDriverForm) {
      setInvalidFields({});
      setDriverData({});
    }
  }, [showDriverForm]);

  return <form className="step step--3" onSubmit={showDriverForm ? handleSaveDriver : handleNextStep}>
    <h2 className="step__title">{t("step3.title")}</h2>
    <p className="step__subtitle">{t("step3.subtitle")}</p>

    {showDriverForm ? (
      <CustomerForm
        formData={driverData}
        setFormData={setDriverData}
        invalidFields={invalidFields}
        setInvalidFields={setInvalidFields}
      />
    ) : (
      <div className="step__content">
        <div className="drivers">
          {additionalDrivers.length > 0 && (
            <div className="drivers__list">
              {additionalDrivers.map((driver, index) => (
                <div className="driver" key={index}>
                  <span>{driver.name} {driver.surname}</span>
                  <button type="button" className="driver__edit" onClick={() => handleEditDriver(index)}></button>
                  <button type="button" className="driver__delete" onClick={() => handleDeleteDriver(index)}></button>
                </div>
              ))}
            </div>
          )}

          {additionalDrivers.length < maxAdditionalDrivers && (
            <div className="drivers__add" onClick={handleAddDriver}>
              {t("driver.add")}
            </div>
          )}
        </div>

        {deleteIndex !== null && (
          <ConfirmBox
            className="delete"
            proceedText={t("driver.delete.confirm")}
            cancelText={t("driver.delete.cancel")}
            onProceed={handleConfirmDelete}
            onCancel={() => setDeleteIndex(null)}
          >
            <h2>{t("driver.delete.title")}</h2>
            <p>{t("driver.delete.description")}</p>
          </ConfirmBox>
        )}
      </div>
    )}

    <ButtonNext disabled={isButtonNextDisabled} />
  </form>;
};

export default Step3;
